import { render, staticRenderFns } from "./BusinessRule.vue?vue&type=template&id=617a6c73&scoped=true"
import script from "./BusinessRule.vue?vue&type=script&lang=js"
export * from "./BusinessRule.vue?vue&type=script&lang=js"
import style0 from "./BusinessRule.vue?vue&type=style&index=0&id=617a6c73&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617a6c73",
  null
  
)

export default component.exports